<!--
 * @Author: your name
 * @Date: 2021-08-02 11:51:05
 * @LastEditTime: 2021-09-07 19:24:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\login\Login.vue
-->
<template>
  <div class="login">
    <el-form ref="loginForm" class="login-form" :model="loginForm" :rules="rules">
      <el-form-item>
        <h2 class="login-title">登  录</h2>
      </el-form-item>
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          placeholder="请输入账号"
          @keydown.enter.native="userLogin('loginForm')"
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          placeholder="请输入密码"
          @keydown.enter.native="userLogin('loginForm')"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          class="login-btn"
          size="mini"
          type="primary"
          @click="userLogin('loginForm')"
        >登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getLogin } from '@/api/user.js'
import { SET_TOKEN, SET_USER } from '@/utils/auth.js'
import md5 from 'js-md5'

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }

    }
  },
  methods: {
    userLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            name: this.loginForm.username,
            password: md5(this.loginForm.password)
          }
          getLogin(data).then(res => {
            if (res.code === 200) {
              SET_TOKEN(res.data.token)
              SET_USER(res.data)
              this.$router.push('/')
              // this.$emit('loginTo', true)
            } else {
              this.$message.warning(res.message)
            }
          }).catch((err) => {
            this.$message.error('登录出错！' + err)
          })
        } else {
          this.$message.warning('请输入账号密码')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  display: flex;
  align-items: center;

  width: 100%;
  height: 99vh;
  .login-form {
    width: 300px;
    padding: 30px 20px 10px;
    margin: 0 auto;
    box-shadow: 0px 0px 16px 0px #ccc;
    border-radius: 6px;
    .login-title{
      text-align: center;
    }
    .login-btn {
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
